import { useEffect, useRef, useState } from 'react'
import { shallowEqual } from '@aytm/lib/common/object'

import PreviewModule from './Module'

import useSession from '../../session/useSession'

import { IPreviewOptions } from './types'

export default function usePreviewOptions(): IPreviewOptions {
  const session = useSession()
  const [currentPreviewOptions, setCurrentPreviewOptions] = useState<IPreviewOptions>(session.previewOptions)
  const currentPreviewOptionsRef = useRef<IPreviewOptions>(currentPreviewOptions)
  currentPreviewOptionsRef.current = currentPreviewOptions

  useEffect(() => {
    const unsubscribe = PreviewModule.onPreviewOptionsUpdate(() => {
      if (!shallowEqual(currentPreviewOptionsRef.current, session.previewOptions)) {
        setCurrentPreviewOptions(session.previewOptions)
      }
    })
    return () => void unsubscribe()
  }, [session])

  return session.previewOptions
}
